import { render } from "./BalSelectInput.vue?vue&type=template&id=474f5c04&scoped=true"
import script from "./BalSelectInput.vue?vue&type=script&lang=ts"
export * from "./BalSelectInput.vue?vue&type=script&lang=ts"

import "./BalSelectInput.vue?vue&type=style&index=0&id=474f5c04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-474f5c04"

export default script